import { render } from "./Architectes.vue?vue&type=template&id=dd23927e&scoped=true"
import script from "./Architectes.vue?vue&type=script&lang=js"
export * from "./Architectes.vue?vue&type=script&lang=js"

import "./Architectes.vue?vue&type=style&index=0&id=dd23927e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd23927e"]])

export default __exports__